// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aZdu","buttons":"styles_buttons__7IHiw"};